import React, { useState, useEffect, useRef } from "react";
import { Modal, Input } from "antd";
import TextArea from "antd/lib/input/TextArea";
import "./PromptModal.less";

const PromptModal = ({
  placeholder = "",
  title = "",
  options,
  isVisible,
  setIsVisible,
  promiseResolve,
}) => {
  const [value, setValue] = useState(options?.default || "");
  const inputRef = useRef();

  useEffect(() => {
    if (isVisible) {
      setValue(options?.default || "");
      inputRef.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  const handleOk = () => {
    setIsVisible(false);
    inputRef.current.blur();
    promiseResolve(value);
  };

  const handleCancel = () => {
    setIsVisible(false);
    inputRef.current.blur();
    promiseResolve();
  };

  return (
    <Modal
      open={isVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      title={title}
      className="modalPrompt"
    >
      {options?.type === "textarea" ? (
        <TextArea
          ref={inputRef}
          style={{ marginTop: "15px" }}
          placeholder={placeholder}
          value={value}
          autoSize={{
            minRows: 2,
            maxRows: 6,
          }}
          onChange={e => setValue(e.target.value)}
        />
      ) : (
        <Input
          ref={inputRef}
          autoFocus
          style={{ marginTop: "15px" }}
          placeholder={placeholder}
          value={value}
          onChange={e => setValue(e.target.value)}
          size="large"
        />
      )}
    </Modal>
  );
};

export default PromptModal;

export const usePromptModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [promiseResolve, setPromiseResolve] = useState(null);
  const [placeholder, setPlaceholder] = useState("");
  const [title, setTitle] = useState("");
  const [options, setOptions] = useState({ default: "", type: "input" });

  const prompt = (placeholder, title, options = { default: "", type: "input" }) => {
    setIsVisible(true);
    setPlaceholder(placeholder);
    setTitle(title);
    if (typeof options === "string") {
      options = { default: options, type: "input" };
    }
    setOptions(options);

    return new Promise(resolve => {
      setPromiseResolve(() => resolve);
    });
  };

  return [
    prompt,
    <PromptModal
      isVisible={isVisible}
      setIsVisible={setIsVisible}
      promiseResolve={promiseResolve}
      placeholder={placeholder}
      title={title}
      options={options}
    />,
  ];
};
